import React, { createContext, useState } from 'react';

interface ActiveNavContextValue {
  activeNavKey?: string;
  setActiveNavKey: (key?: string) => void;
}

const ActiveNavContext = createContext<ActiveNavContextValue | null>(null);

// Lets a screen tell the sidebar which option it belongs to when the URL alone is ambiguous
// (e.g. /providers/:id can be an employee or an external provider).
export const ActiveNavProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeNavKey, setActiveNavKey] = useState<string>();

  return (
    <ActiveNavContext.Provider value={{ activeNavKey, setActiveNavKey }}>
      {children}
    </ActiveNavContext.Provider>
  );
};

export default ActiveNavContext;
